import { IonButton, IonContent, IonIcon, IonInput, IonItem, IonItemDivider, IonList, IonListHeader, IonPage, withIonLifeCycle } from "@ionic/react"
import { key, person } from "ionicons/icons";
import React, { FormEvent } from "react";
import logo from "../images/logo.svg"
import logo_acx from "../images/logo_acromax.svg"
import logo_ss from "../images/logo_salud.svg"

class SplashPage extends React.Component{

    submit = async (e:FormEvent) => {

    }

    render(){
        return (
            <IonPage>
                <IonContent fullscreen className="no-bg fondo-colores">
                    <form className="fixed-center" onSubmit={this.submit}>
                        <IonList lines="none" className="no-bg" mode="md">
                            <IonItem lines="none" className="no-bg">
                                <div style={{textAlign:"center",display:"block",width:"100%"}}>
                                    <img src={logo} alt="Acrofit" width={200} />
                                </div>
                            </IonItem>
                            <IonItem lines="none" className="no-bg" >
                                <p style={{textAlign:"center",display:"block",width:300}}>
                                Esta app está diseñada para ayudarte a llevar un control de tu peso y alimentación. <br/><br/>
Podrás llevar un recuento de cuántas calorías consumes a lo largo del día y si estás por buen camino hasta llegar a tu objetivo.
                                </p>
                            </IonItem>
                            <IonButton color="tertiary" routerLink="/login" expand="block" fill="clear">{"<< Continuar >>"}</IonButton>
                            <IonItem lines="none" className="no-bg">
                                <div style={{textAlign:"center",display:"block",width:"100%"}}>
                                    <img src={logo_acx} alt="Acrofit" width={80} />
                                </div>
                            </IonItem>
                            <IonItem lines="none" className="no-bg">
                                <div style={{textAlign:"center",display:"block",width:"100%"}}>
                                    <img src={logo_ss} alt="Acrofit" width={200} />
                                </div>
                            </IonItem>
                        </IonList>
                    </form>
                </IonContent>
            </IonPage>
        )
    }
}

export default withIonLifeCycle(SplashPage);